import { createFileRoute } from "@tanstack/react-router";
import { DiagnosticsPage } from "../features/diagnostics/pages/diagnostics-page";

export const Route = createFileRoute("/diagnostics")({
  component: DiagnosticsPage,
});
